
webpack.register(
    'blocks/leaderboard-drawer/shot-by-shot/shot-by-shot',
    function() {
        return import('blocks/leaderboard-drawer/shot-by-shot/shot-by-shot');
    },
    true
);